<template>
    <div>
        <multiselect
                :options="items"
                track-by="id"
                label="label"
                :placeholder=placeholder
                :value="selectedCodec"
                :disabled="!canChange"
                @input="selectCodec"
                @remove="unselectCodec"
        />
        <div class="invalid-feedback" style="display: block" v-if="fieldErrors">
            {{ fieldErrors }}
        </div>
    </div>
<!--                v-model="selectedCodec"-->
</template>

<script>
    // import PriceListService from "../services/price_list.service"
    import Multiselect from "vue-multiselect"

    export default {
        // TODO: rename in PSelectPriceList
        name: "CodecSelect",

        components: {
            Multiselect
        },

        props: {
            items: {
                type: Array
            },

            addPromoItem: {
                type: Boolean,
                default: false
            },

            value: {
                type: Object
            },

            picaServiceId: {
                type: Number,
                required: false
            },

            labelEmptyValue: {
                type: String,
                default: function() { return this.$gettext('Select...') } // 'Seleziona...'
            },

            placeholder: {
                type: String,
                default: function() { return this.$gettext('Select a codec...') } // "Scegli il listino..."
            },

            fieldErrors: {
                type: String
            },

            canChange: {
                type: Boolean,
                default: true
            },
        },

        data() {
            return {
                // priceLists: [],
                selectedCodec: this.value,
                promoItem: {
                    "id": 0,
                    "name": this.$gettext('Free photos'),
                }
            }
        },

        // mounted() {
        //     if (this.priceLists)
        //         this.priceLists = this.items
        //     else
        //         this.loadPriceList()
        // },


        methods: {
            // loadPriceList() {
            //     console.log('loadPriceList')
            //     PriceListService.getPriceLists(this.picaServiceId || null)
            //         .then((response) => {
            //             this.priceLists = response.data.results
            //         })
            // },

            selectCodec(e) {
                // console.log('selectCodec', e)
                this.selectedCodec = e
                this.$emit('input', e)
            },

            unselectCodec(e) {
                // console.log('unselectCodec', e)
                this.$emit('remove', e)
            }
        }
    }
</script>
